export default __webpack_public_path__ + "static/media/60.a07ee3b2.jpg";